// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiBox-root.notFoundContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 60vh;
    padding: 20px 40px;
}

.notFoundImage {
    width: 100%;
    max-width: 187px;
    height: 187px;
    margin-bottom: 20px;
}

.MuiTypography-root.pageNotFoundTitle {
    font-size: 28px;
    color: #FFFFFF;
    text-align: center;
    font-family: var(--font-family-primary);
    font-weight: 400;
    line-height: 1.5;
}

.MuiTypography-root.pageNotFoundDescription {
    font-size: 16px;
    color: #EBEBF599;
    text-align: center;
    font-family: var(--font-family-primary);
    font-weight: 400;
    line-height: 1.5;
}

.notFoundButtonContainer {
    margin: 20px 0px;
    width: 100%;
    display: flex;
    justify-content: center;
}

.notFoundButtonContainer:focus-visible {
    outline: none;
    border: none;
}

@media screen and (min-width: 768px) {
    .notFoundButtonContainer .MuiButtonBase-root {
        width: 25%;
    }
}

@media screen and (min-width: 1440px) {
    .notFoundButtonContainer .MuiButtonBase-root {
        width: 10%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/NotFound/Notfound.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,uCAAuC;IACvC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,uCAAuC;IACvC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ","sourcesContent":[".MuiBox-root.notFoundContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    height: 60vh;\n    padding: 20px 40px;\n}\n\n.notFoundImage {\n    width: 100%;\n    max-width: 187px;\n    height: 187px;\n    margin-bottom: 20px;\n}\n\n.MuiTypography-root.pageNotFoundTitle {\n    font-size: 28px;\n    color: #FFFFFF;\n    text-align: center;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    line-height: 1.5;\n}\n\n.MuiTypography-root.pageNotFoundDescription {\n    font-size: 16px;\n    color: #EBEBF599;\n    text-align: center;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    line-height: 1.5;\n}\n\n.notFoundButtonContainer {\n    margin: 20px 0px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n}\n\n.notFoundButtonContainer:focus-visible {\n    outline: none;\n    border: none;\n}\n\n@media screen and (min-width: 768px) {\n    .notFoundButtonContainer .MuiButtonBase-root {\n        width: 25%;\n    }\n}\n\n@media screen and (min-width: 1440px) {\n    .notFoundButtonContainer .MuiButtonBase-root {\n        width: 10%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
